var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('keep-alive',{attrs:{"include":_vm.keepAliveConfig}},[_c('router-view',{staticStyle:{"padding-bottom":"100px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }